export const SWITCH_THEME = "SWITCH_THEME";
